import { render, staticRenderFns } from "./PrintDeptRatingDialog.vue?vue&type=template&id=1e0c7873"
import script from "./PrintDeptRatingDialog.vue?vue&type=script&lang=js"
export * from "./PrintDeptRatingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports